import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    IntegrationFormSubmit as IntegrationFormSubmitMutation,
    IntegrationFormSubmitVariables as IntegrationFormSubmitMutationVariables,
    IntegrationFormSubmitInput,
} from 'nutshell-graphql-types';

import INTEGRATION_FORM_SUBMIT from '../mutations/integration-form-submit.graphql';

export function useIntegrationFormSubmit(): {
    integrationFormSubmit: (input: IntegrationFormSubmitInput) => Promise<any>;
    error: string | null | undefined;
} {
    const [integrationFormSubmit, {error}] = useMutation<
        IntegrationFormSubmitMutation,
        IntegrationFormSubmitMutationVariables
    >(INTEGRATION_FORM_SUBMIT);

    try {
        return {
            integrationFormSubmit: (input: IntegrationFormSubmitInput) =>
                integrationFormSubmit({
                    variables: {input},
                }).catch((err: Error) => {
                    return [err.name, err.message];
                }),
            // @ts-expect-error
            error: safelyGetGraphQLErrorMessage(error),
        };
    } catch (err: any) {
        // eslint-disable-next-line no-console
        console.error(err);

        return err;
    }
}
